import { Outlet } from '@tanstack/react-router';
import type { ReactNode } from 'react';

/** The root route renders nothing of its own: layout belongs to the layout routes below it. */
export function RootLayout(): ReactNode {
  return <Outlet />;
}
